import Axios from 'axios'
import store from '~/store'
import { logout } from '~/store/auth/slice'
import { AUTH_TOKEN } from '~/utils/constants'

const REQUEST_TIMEOUT = 30000

export const client = Axios.create({
  baseURL: import.meta.env.VITE_BASE_APP_URL || window.location.origin,
  timeout: REQUEST_TIMEOUT,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

client.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response.status === 401) {
      if (window.location.pathname !== 'signin') {
        localStorage.removeItem(AUTH_TOKEN)
        store.dispatch(logout())
      }
    }
    return Promise.reject(error)
  }
)

export const setApiClientAuthToken = (t) => {
  client.defaults.headers.common.Authorization = t ? `Bearer ${t}` : ''
  client.defaults.headers.common['X-CSRF-TOKEN'] = t
}

setApiClientAuthToken(localStorage.getItem(AUTH_TOKEN))
